import LogoSherpa2025 from './LogoSherpa2025'

export default LogoSherpa2025
// eslint-disable-next-line import/export
export * from './LogoSherpa2025'
